// @flow
import * as React from 'react';

type SuperscriptProps = {|
  children: React.Node,
|};

export const Superscript = ({children}: SuperscriptProps) => (
  <sup>{children}</sup>
);
